import { db } from "./firebase";
import { doc, getDoc, setDoc, deleteDoc, collection, getDocs, query, where } from "firebase/firestore";

const COL     = "checkvan";
const FAC_COL = "checkvan_factures";

export async function loadAll(userId) {
  if (!userId) return null;
  const snap = await getDoc(doc(db, COL, userId));
  return snap.exists() ? snap.data() : {};
}

export async function saveKey(userId, key, value) {
  if (!userId) return;
  const docRef = doc(db, COL, userId);
  const payload = typeof value === "object" && value !== null
    ? { [key]: JSON.stringify(value) }
    : { [key]: value };
  await setDoc(docRef, payload, { merge: true });
}

// meta = { date: "2025-05-17", categorie: "Garage" }
export async function saveFacture(userId, factureId, imageBase64, meta = {}) {
  if (!userId || !factureId || !imageBase64) return;
  console.log("[Firestore] saveFacture → id:", factureId, "| taille:", imageBase64.length, "chars");
  try {
    const ref = doc(db, FAC_COL, `${userId}_${factureId}`);
    await setDoc(ref, {
      userId,
      factureId:  String(factureId),
      image:      imageBase64,
      date:       meta.date      || "",
      categorie:  meta.categorie || "",
    });
    console.log("[Firestore] ✅ Facture sauvée (date:", meta.date, "| cat:", meta.categorie, ")");
  } catch (e) {
    console.error("[Firestore] ❌ Erreur saveFacture:", e.message);
  }
}

export async function loadFactures(userId) {
  if (!userId) return [];
  console.log("[Firestore] loadFactures → userId:", userId);
  try {
    const q    = query(collection(db, FAC_COL), where("userId", "==", userId));
    const snap = await getDocs(q);
    const results = snap.docs.map(d => ({
      factureId: Number(d.data().factureId),
      image:     d.data().image,
      date:      d.data().date      || "",
      categorie: d.data().categorie || "",
    }));
    console.log("[Firestore] ✅ Factures récupérées:", results.length);
    return results;
  } catch (e) {
    console.error("[Firestore] ❌ Erreur loadFactures:", e.message);
    return [];
  }
}

export async function deleteAllUserData(userId) {
  if (!userId) return;
  await deleteDoc(doc(db, COL, userId));
  const q    = query(collection(db, FAC_COL), where("userId", "==", userId));
  const snap = await getDocs(q);
  await Promise.all(snap.docs.map(d => deleteDoc(d.ref)));
}

export async function deleteFacture(userId, factureId) {
  if (!userId || !factureId) return;
  console.log("[Firestore] deleteFacture → id:", factureId);
  try {
    await deleteDoc(doc(db, FAC_COL, `${userId}_${factureId}`));
    localStorage.removeItem("checkvan_facture_" + factureId);
    console.log("[Firestore] ✅ Facture supprimée:", factureId);
  } catch (e) {
    console.error("[Firestore] ❌ Erreur deleteFacture:", e.message);
    localStorage.removeItem("checkvan_facture_" + factureId);
  }
}
